import { css } from '@emotion/react';

interface InputLabelTitleProps {
  title: string;
  id?: string;
}

export default function InputLabelTitle({ title, id }: InputLabelTitleProps) {
  return (
    <div
      css={css`
        display: block;

        em {
          display: block;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: -0.1px;
          line-height: 22px;
        }
      `}
    >
      {id ? (
        <label htmlFor={id}>
          <em>{title}</em>
        </label>
      ) : (
        <em>{title}</em>
      )}
    </div>
  );
}
